import { getCountryNameFromPhoneNumber } from '@/utils/countryUtils'

function formatDate(dateValue) {
  if (dateValue == null) return ''

  const date = new Date(dateValue)
  if (Number.isNaN(date.getTime())) return ''

  const year = date.getFullYear()
  const month = (`0${date.getMonth() + 1}`).slice(-2)
  const day = (`0${date.getDate()}`).slice(-2)

  return `${year}-${month}-${day}`
}

export function getLicenseValidUntilTimestamp(license) {
  if (!license || license.valid === false) return null

  const value = license.validuntil ?? license.validUntil
  if (value == null || value === '') return null

  const numericValue = Number(value)
  if (Number.isFinite(numericValue)) return numericValue

  const parsedValue = new Date(value).getTime()
  return Number.isFinite(parsedValue) ? parsedValue : null
}

export function getLongestValidLicense(licenses) {
  if (!Array.isArray(licenses)) return null

  let longestLicense = null
  let longestTimestamp = null

  for (const license of licenses) {
    const timestamp = getLicenseValidUntilTimestamp(license)
    if (!Number.isFinite(timestamp)) continue
    if (longestTimestamp == null || timestamp > longestTimestamp) {
      longestTimestamp = timestamp
      longestLicense = license
    }
  }

  return longestLicense
}

export function normalizeAdminUser(rawUser = {}) {
  const user = {
    ...rawUser
  }

  user.teamsinfo = Array.isArray(user.teamsinfo) ? user.teamsinfo : []

  user.placesmin = user.places
  user.placesmax = user.places
  user.all_huntsmin = user.all_hunts
  user.all_huntsmax = user.all_hunts
  user.created_huntsmin = user.created_hunts
  user.created_huntsmax = user.created_hunts

  user.licenseslength = 0
  user.last_license_date = ''

  if (Array.isArray(user.licenses)) {
    const licenseCount = user.licenses.length

    user.licenseslength = licenseCount
    user.licenseslengthmin = licenseCount
    user.licenseslengthmax = licenseCount

    if (licenseCount > 0) {
      const longestLicense = getLongestValidLicense(user.licenses)
      const longestLicenseDate = getLicenseValidUntilTimestamp(longestLicense)
      if (Number.isFinite(longestLicenseDate)) {
        user.licenseslastdatemin = longestLicenseDate
        user.licenseslastdatemax = longestLicenseDate
        user.last_license = longestLicenseDate
        user.last_license_date = formatDate(longestLicenseDate)
      }
    }
  }

  user.deviceslength = 0
  if (Array.isArray(user.devices)) {
    const deviceCount = user.devices.length
    user.deviceslength = deviceCount
    user.deviceslengthmin = deviceCount
    user.deviceslengthmax = deviceCount
  }

  user.created_date = ''
  if (user.created != null) {
    user.createddatemin = user.created
    user.createddatemax = user.created
    user.created_date = formatDate(user.created)
  }

  user.last_joined_date = ''
  if (user.last_joined != null) {
    user.last_joineddatemin = user.last_joined
    user.last_joineddatemax = user.last_joined
    user.last_joined_date = formatDate(user.last_joined)
  }

  user.noteslength = 0
  if (Array.isArray(user.activity)) {
    for (let index = 0; index < user.activity.length; index += 1) {
      if (user.activity[index].name === 'admin_note') {
        user.noteslength = user.activity[index].count
        break
      }
    }
    user.noteslengthmin = user.noteslength
    user.noteslengthmax = user.noteslength
  }

  user.country = getCountryNameFromPhoneNumber(user.cellnumber)

  user.app = ''
  user.phone = ''

  if (Array.isArray(user.devices) && user.devices.length > 0) {
    const appVersion = String(user.devices[0].appversion || '').slice(-1)
    const operatingSystem = user.devices[0].opsys

    if (appVersion === '1') user.app = 'Huntloc'
    else if (appVersion === '2') user.app = 'Liveteam'
    else if (appVersion === '3') user.app = 'Doglo'

    if (operatingSystem === 'android') user.phone = 'Android'
    if (operatingSystem === 'iPhone OS') user.phone = 'iOS'
    if (operatingSystem === 'iOS') user.phone = 'iOS'
  }

  return user
}

export function normalizeAdminUsers(users) {
  if (!Array.isArray(users)) return []
  return users.map((user) => normalizeAdminUser(user))
}
